{
  "Accessibility menu": "ადაპტირებული მენიუ",
  "Reset settings": "პარამეტრების დაბრუნება",
  "Close": "დახურვა",
  "Content adjustments": "შიგთავსის მორგება",
  "Navigation adjustments": "ნავიგაციის მორგება",
  "Align Left": "მარცხნივ გასწორება",
  "Adjust Font Size": "ფონტის ზომის მორგება",
  "Highlight Title": "სათაურების გამოყოფა",
  "Highlight Links": "ბმულების გამოყოფა",
  "Readable Font": "წაკითხვადი ტექსტები",
  "Colour adjustments": "ფერების მორგება",
  "Dark Contrast": "ბნელი ელფერი",
  "Light Contrast": "ნათელი ელფერი",
  "High Contrast": "მაღალი ელფერი",
  "High Saturation": "მაღალი გაჯერება",
  "Low Saturation": "დაბალი გაჯერება",
  "Monochrome": "ერთფეროვანი გამოსახულება",
  "Tools": "ხელსაწყოები",
  "Reading Guide": "კითხვის გამყოლი ზოლი",
  "Stop Animations": "ანიმაციების გაჩერება",
  "Big Cursor": "დიდი კურსორი",
  "Increase Font Size": "ფონტის ზომის გაზრდა",
  "Decrease Font Size": "ფონტის ზომის შემცირება",
  "Letter Spacing": "ასოებს შორის დაშორება",
  "Line Height": "ხაზის სიმაღლე",
  "Font Weight": "ფონტის წონა",
  "Dyslexia Font": "დისლექსიური ფონტი",
  "Language": "ენა",
  "Accessibility widget": "გახსენი ადაპტირებული მენიუ",
  "Accessibility Profiles": "ადაპტირებული პროფილები",
  "Cognitive Disability": "კოგნიტიური შეზღუდვა",
  "Seizure Safe": "უსაფრთხო ეპილეფსიისთვის",
  "Accessibility statement": "ადაპტირების დეკლარაცია"
}
